/**
 * 応募者情報解析レポートページ
 * このページは、応募者の選考状況や媒体別応募数を集計し、指定された期間に基づいて可視化します。
 * ユーザは期間を指定してデータをフィルタリングでき、結果をクリップボードにコピーすることも可能です。
 */
<template>
  <div class="root-container">
    <div class="report-wrapper">
      <div class="container-report disp-scroll" :class="{'container-setting': !isMenuMiniSize, 'container-setting-thin-menu': isMenuMiniSize}">
        <!-- 解析レポート① -->
        <div class="header-box">
          <div class="header-menu">
            <p><b style="font-size:28px; font-weight: 800;">解析レポート①</b></p>
            <p style="margin-left: 25px; font-size:16px; color: #666; margin-top: 8px;">応募者情報</p>
          </div>
        </div>
        <div class="parent-container">
          <div class="title-container">
                集計したい項目を指定・反映してください。反映後、各項目を絞り込んだり、集計が可能です。
                <br>※アーカイブ、採用停止、削除区分の方は集計から除外
          </div>
          <div class="checkbox-header">
            <h2 class="checkbox-section-title">１）下記より、５つまで集計項目を選択し、作成ボタンを押下ください</h2>
            <button @click="updateReportFlgs" :disabled="!hasSelectedColumns" class="reflect-button" :class="{ 'disabled': !hasSelectedColumns }">
              集計項目を作成
            </button>
          </div>
          <!-- 変更: 薄いグレーの四角枠を追加 -->
          <div class="checkbox-outer-container">
            <!-- 変更: グリッドコンテナを4列に設定 -->
            <div class="checkbox-grid-container">
              <div v-for="(reportColumn, index) in filteredReportColumns" :key="reportColumn.pk" class="checkbox-item">
                <label>
                  <input type="checkbox" v-model="reportColumn.is_report_flg" :value="reportColumn.pk" :disabled="isDisabled(reportColumn)" class="checkbox-input">
                  <span class="checkbox-checkmark" :class="{ 'disabled': isDisabled(reportColumn) }"></span>
                  {{ reportColumn.name }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="parent-container">
          <div class="checkbox-header">
            <h2 class="checkbox-section-title">２）集計期間、絞込み、縦横の項目をすべて選び、「テーブルを表示」を押下ください</h2>
            <button @click="fetchSeekerSummaryTabulation" :disabled="!allFieldsSelected" class="reflect-button" :class="{ 'disabled': !allFieldsSelected }">
              テーブルを表示
            </button>
          </div>
          <div class="checkbox-outer-container">
            <div style="display: flex; flex-wrap: wrap; align-items: center; padding: 20px;">
              <div class="date-range">
                <div class="date-input-group">
                  <label>開始</label>
                  <input class="input date-input" type="month" name="monthFrom" v-model="exportMonthFrom2" :max="exportMonthTo2" :min="minYearMonth1" />
                </div>
                <div class="date-input-group">
                  <label>～終了</label>
                  <input class="input date-input" type="month" name="monthTo" v-model="exportMonthTo2" :min="exportMonthFrom2" :max="maxYearMonth1" />
                </div>
              </div>
              <div class="filter-and-columns">
                <div class="filter-section">
                  <select v-model="selectedFilterOption" class="select-container">
                    <option value="">絞込み（選択必須）</option>
                    <option v-for="filterColumn in filterColumns" :key="filterColumn.id" :value="filterColumn.id">
                      {{ filterColumn.name }}
                    </option>
                    <option value="media_name">媒体</option>
                    <option value="stage_name">ステージ</option>
                    <option value="status_name">ステータス</option>
                    <option value="action_name">アクション</option>
                  </select>
                  <select v-if="selectedFilterOption" v-model="selectedFilterValue" multiple class="select-container multi-select">
                    <option v-for="option in getFilterOptions(selectedFilterOption)" :key="option" :value="option">
                      {{ option }}
                    </option>
                  </select>
                </div>
                <div class="column-selectors">
                  <select v-model="selectedVerticalColumns1" class="select-container">
                    <option value="">縦項目（大分類）</option>
                    <option v-for="filterColumn in filterColumns" :key="filterColumn.id" :value="filterColumn.id">
                      {{ filterColumn.name }}
                    </option>
                    <option value="yearmonth">年月</option>
                    <option value="media_name">媒体</option>
                    <option value="stage_name">ステージ</option>
                    <option value="status_name">ステータス</option>
                    <option value="action_name">アクション</option>
                  </select>
                  <select v-model="selectedVerticalColumns2" class="select-container">
                    <option value="">縦項目（小分類）</option>
                    <option v-for="filterColumn in filterColumns" :key="filterColumn.id" :value="filterColumn.id">
                      {{ filterColumn.name }}
                    </option>
                    <option value="yearmonth">年月</option>
                    <option value="media_name">媒体</option>
                    <option value="stage_name">ステージ</option>
                    <option value="status_name">ステータス</option>
                    <option value="action_name">アクション</option>
                  </select>
                  <select v-model="selectedHorizontalColumns1" class="select-container">
                    <option value="">横項目</option>
                    <option v-for="filterColumn in filterColumns" :key="filterColumn.id" :value="filterColumn.id">
                      {{ filterColumn.name }}
                    </option>
                    <option value="yearmonth">年月</option>
                    <option value="media_name">媒体</option>
                    <option value="stage_name">ステージ</option>
                    <option value="status_name">ステータス</option>
                    <option value="action_name">アクション</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="parent-container">
          <div v-if="isLoading" class="loading-overlay">
            <div class="loading-spinner"></div>
          </div>
          <div v-else-if="showTable" class="table-container">
            <div style="display: flex; flex-direction: column; align-items: center;">
              <table style="white-space: nowrap; margin: 0 auto;">
                <thead>
                  <tr>
                    <th v-if="verticalColumn1">{{ getColumnName(verticalColumn1) }}</th>
                    <th v-if="verticalColumn2">{{ getColumnName(verticalColumn2) }}</th>
                    <th v-for="column in getUniqueColumnValues(horizontalColumn)" :key="column">{{ column === null ? '-' : column }}</th>
                    <th>合計</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(verticalValue1, index1) in getUniqueColumnValues(verticalColumn1)">
                    <template v-for="(verticalValue2, index2) in getUniqueColumnValues(verticalColumn2, verticalValue1)">
                      <tr :key="`row-${index1}-${index2}`">
                        <td v-if="index2 === 0" :rowspan="getRowSpan(verticalValue1)" style="text-align: left; padding-left: 10px;">{{ verticalValue1 === null ? '-' : verticalValue1 }}</td>
                        <td style="text-align: left; padding-left: 10px;">{{ verticalValue2 === null ? '-' : verticalValue2 }}</td>
                        <template v-for="horizontalValue in getUniqueColumnValues(horizontalColumn)">
                          <td :key="horizontalValue">
                            {{ getColumnValue(verticalValue1, verticalValue2, horizontalValue) === null ? '-' : getColumnValue(verticalValue1, verticalValue2, horizontalValue) }}
                          </td>
                        </template>
                        <td>{{ calculateRowTotal(verticalValue1, verticalValue2) === null ? '-' : calculateRowTotal(verticalValue1, verticalValue2) }}</td>
                      </tr>
                    </template>
                    <tr :key="`subtotal-${index1}`" class="subtotal-row" v-if="showTable">
                      <td :colspan="2" style="text-align: left; padding-left: 10px;">{{ verticalValue1 === null ? '-' : verticalValue1 }} 小計</td>
                      <template v-for="horizontalValue in getUniqueColumnValues(horizontalColumn)">
                        <td :key="horizontalValue">
                          {{ calculateVerticalSubtotal(verticalValue1, horizontalValue) === null ? '-' : calculateVerticalSubtotal(verticalValue1, horizontalValue) }}
                        </td>
                      </template>
                      <td>{{ calculateVerticalTotal(verticalValue1) === null ? '-' : calculateVerticalTotal(verticalValue1) }}</td>
                    </tr>
                  </template>
                  <tr class="total-row" v-if="showTable">
                    <td :colspan="verticalColumns.length" style="text-align: left; padding-left: 10px;">総合計</td>
                    <template v-for="horizontalValue in getUniqueColumnValues(horizontalColumn)">
                      <td :key="horizontalValue">
                        {{ calculateHorizontalTotal(horizontalValue) === null ? '-' : calculateHorizontalTotal(horizontalValue) }}
                      </td>
                    </template>
                    <td>{{ calculateGrandTotal() === null ? '-' : calculateGrandTotal() }}</td>
                  </tr>
                </tbody>
              </table>
              <div v-if="showTable" style="text-align: center; margin-top: 20px;">
                <button @click="downloadExcel" class="download-button">Excelダウンロード</button>
              </div>
            </div>
          </div>
        </div>
        <template v-if="false">
        <!--[COMMENT_START]-->
        <!-- 解析レポート② -->
        <div class="header-box">
          <div class="header-menu">
            <p><b style="font-size:28px; font-weight: 800;">解析レポート②</b></p>
            <p style="margin-left: 25px; font-size:16px; color: #666; margin-top: 8px;">応募者情報</p>
          </div>
        </div>
        <div class="parent-container">
          <div class="title-container">
            媒体別の応募者の年月推移を表で確認できます。集計したい期間を指定してください。（期間最長２年）
            <br>※アーカイブ、採用停止、削除区分の方は集計から除外
          </div>
          <div style="display: flex; align-items: center; justify-content: space-between; margin-top: 20px;">
            <div style="display: flex; align-items: center;">
              <div style="width: 240px; margin-right: 20px;">
                <input class="input" type="month" name="monthFrom" v-model="exportMonthFrom" :max="thisMonth" />
              </div>
              <p style="margin: 0 16px;">～</p>
              <div style="width: 240px;">
                <input class="input" type="month" name="monthTo" v-model="exportMonthTo" :min="exportMonthFrom" :max="thisMonth" />
              </div>
            </div>
            <div>
              <button @click="fetchStageData" style="margin-right: 10px;">選考状況別表示</button>
              <button @click="fetchAggregatedData" style="margin-right: 10px;">媒体別応募表示</button>
              <button @click="fetchAggregatedMessages" style="margin-right: 10px;">時間帯別会話表示</button>
              <button @click="copyTableToClipboard" :disabled="totalMediaNameDataCount === 0" class="copy-button" :class="{ 'button-disabled': totalMediaNameDataCount === 0 }">
                <i class="copy-icon">📋</i> コピー（表）
              </button>
            </div>
            <!-- 時間帯別会話表示のグラフをボタン押下後に表示 -->
            <bar-chart v-if="loadedChartData" :chart-data="loadedChartData" :options="chartOptions" class="custom-chart-width"></bar-chart>
            <div v-if="loadedChartData">
              <span class="aggregated-text">会話総合計数:</span>
              <span class="aggregated-emtext">{{ totalConversations }}</span>
              <span class="aggregated-text">／月平均会話件数:</span>
              <span class="aggregated-emtext">{{ averageConversationsPerMonth }}</span>
              <span class="aggregated-text">（選択期間内）</span>
              <table class="aggregated-table">
                <thead>
                  <tr>
                    <th></th>
                    <th v-for="bot in uniqueBots" :key="bot">{{ bot }}</th>
                    <th>合計</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="status in uniqueStatuses" :key="status">
                    <th>{{ getStatusLabel(status) }}</th>
                    <td v-for="bot in uniqueBots" :key="bot">{{ getConversationCount(bot, status) }}</td>
                    <td>{{ getTotalConversationsByStatus(status) }}</td>
                  </tr>
                  <tr>
                    <th>合計</th>
                    <td v-for="bot in uniqueBots" :key="bot">{{ getTotalConversationsByBot(bot) }}</td>
                    <td>{{ totalConversations }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
        </div>
        <!-- 選考状況 -->
        <div class="report-container">
          <div v-if="totalStageDataCount > 0">
            <h2 class="table-title">選考状況</h2>
            <table class="stage-table">
              <thead>
                <tr>
                  <th v-for="stage in uniqueStages" :key="`header-${stage}`">{{ stage }}</th>
                  <th>合計</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td v-for="stage in uniqueStages" :key="`count-${stage}`">
                    <span class="count">{{ getStageCount(stage) }}</span><span class="unit">人</span>
                  </td>
                  <td><span class="count">{{ totalStageDataCount }}</span><span class="unit">人</span></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else></div>
          </div>
          <table v-if="totalMediaNameDataCount > 0">
            <thead>
              <tr>
                <th>媒体名</th>
                <th v-for="month in computedMonths" :key="month">{{ month }}</th>
                <th>期間合計</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="media in sortedMediaName" :key="media">
                <td>{{ media }}</td>
                <td v-for="month in computedMonths" :key="month">
                  <font color="black">{{ getDataByMediaNameAndMonth(media, month) || 0 }}</font>
                </td>
                <td><font color="black">{{ totalByMediaName[media] }}</font></td>
              </tr>
              <tr>
                <td>媒体合計</td>
                <td v-for="month in computedMonths" :key="month">
                  <font color="black">{{ totalByMonth[month] }}</font>
                </td>
                <td><font color="black">{{ grandTotal }}</font></td>
              </tr>
            </tbody>
          </table>
          <div v-else></div>
        </div>
        <!-- 選考状況 -->
        <div class="report-container">
          <div v-if="totalStageDataCount > 0">
            <h2 class="table-title">選考状況</h2>
            <table class="stage-table">
              <thead>
                <tr>
                  <th v-for="stage in uniqueStages" :key="`header-${stage}`">{{ stage }}</th>
                  <th>合計</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td v-for="stage in uniqueStages" :key="`count-${stage}`">
                    <span class="count">{{ getStageCount(stage) }}</span><span class="unit">人</span>
                  </td>
                  <td><span class="count">{{ totalStageDataCount }}</span><span class="unit">人</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 時間帯別会話表示のグラフをボタン押下後に表示 -->
        <bar-chart v-if="loadedChartData" :chart-data="loadedChartData" :options="chartOptions" class="custom-chart-width"></bar-chart>
        <div v-if="loadedChartData">
          <span class="aggregated-text">会話総合計数:</span>
          <span class="aggregated-emtext">{{ totalConversations }}</span>
          <span class="aggregated-text">／月平均会話件数:</span>
          <span class="aggregated-emtext">{{ averageConversationsPerMonth }}</span>
          <span class="aggregated-text">（選択期間内）</span>
          <table class="aggregated-table">
            <thead>
              <tr>
                <th></th>
                <th v-for="bot in uniqueBots" :key="bot">{{ bot }}</th>
                <th>合計</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="status in uniqueStatuses" :key="status">
                <th>{{ getStatusLabel(status) }}</th>
                <td v-for="bot in uniqueBots" :key="bot">{{ getConversationCount(bot, status) }}</td>
                <td>{{ getTotalConversationsByStatus(status) }}</td>
              </tr>
              <tr>
                <th>合計</th>
                <td v-for="bot in uniqueBots" :key="bot">{{ getTotalConversationsByBot(bot) }}</td>
                <td>{{ totalConversations }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      <!--[COMMENT_END]-->
      </template>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import BarChart from '@/components2/Report/BarChart'
import * as XLSX from 'xlsx';

// ランダムな色を生成する関数を追加
function getRandomColor() {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export default {
  components: {
    BarChart
  },
  data() {
    return {
      aggregatedData: [],
      stageData: [], // ステージごとのデータを格納する配列を追加
      messageData: [], // ダイレクトメッセージを格納する配列を追加
      exportMonthFrom: '',
      exportMonthTo: '',
      is_string: false,
      is_recruitpage: false,
      // ローディング状態を追加
      isLoading: false,
      // アラート表示フラグ
      alertShown: false,
      loadedChartData: null,
      chartOptions: {
        duration: 1000,
        easing: 'easeOutQuart',
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            ticks: {
              // すべてのラベルを表示
              autoSkip: false,
              // ラベルの最大回転角度
              maxRotation: 90,
              // ラベルの最小回転角度
              minRotation: 45,
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              userCallback: function(value) {
                // 値に応じて軸のラベルを調整する
                return value.toLocaleString()
              }
            }
          }]
        }
      },
      showTable: false,
      reportColumns: [],
      selectedReportColumnIds: [],
      selectedReportColumns: [],
      maxReportColumns: 5,
      selectedFilterOption: '',//セレクトボックスの絞り込み項目（単一）
      selectedFilterValue: [],//セレクトボックスの絞り込み（複数可）
      filterOptions: {},
      filterColumns: [],
      _exportMonthFrom2: '',
      _exportMonthTo2: '',
      minYearMonth1: '',
      maxYearMonth1: '',
      selectedVerticalColumns1: '',//縦の分析軸1
      selectedVerticalColumns2: '',//縦の分析軸2
      selectedHorizontalColumns1: '',//横の分析軸
      verticalColumn1: '',
      verticalColumn2: '',
      horizontalColumn: [],
      seekerSummaryData: {
        vertical_column_1: '',
        vertical_column_2: '',
        horizontal_column: '',
        data: []
      },
    }
  },
  mounted() {
    this.fetchFilterOptions();
  },
  computed: {
    ...mapState("setting", ["isMenuMiniSize"]),
    ...mapState('auth', ['user']),
    ...mapState('directtalk', ['seekerSummaryResult']),
    filteredReportColumns() {
      return this.reportColumns.filter(column => {
        const templateType = column.template_type;
        return !(templateType >= 2 && templateType <= 18) && !(templateType >= 22 && templateType <= 30);
      });
    },
    exportMonthFrom2: {
      get() {
        return this.$data._exportMonthFrom2;
      },
      set(value) {
        if (value) {
          this.$data._exportMonthFrom2 = value.slice(0, 7);
        } else {
          this.$data._exportMonthFrom2 = '';
        }
      },
    },
    exportMonthTo2: {
      get() {
        return this.$data._exportMonthTo2;
      },
      set(value) {
        if (value) {
          this.$data._exportMonthTo2 = value.slice(0, 7);
        } else {
          this.$data._exportMonthTo2 = '';
        }
      },
    },
    verticalColumns() {
      return [this.verticalColumn1, this.verticalColumn2].filter(Boolean);
    },
    // is_report_flgがtrueのレポートカラムのみを含む配列を返す
    reportColumnVertical() {
      return this.reportColumns.filter(reportColumn => reportColumn.is_report_flg);
    },
    visibleReportColumns() {
      return this.reportColumns.filter(reportColumn => reportColumn.is_report_flg);
    },
    // 【選択年月関連】現在の年月を取得するロジックを実装
    hasSelectedColumns() {
      return this.reportColumns.some(reportColumn => reportColumn.is_report_flg);
    },
    thisMonth() {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      return `${year}-${month}`
    },
    // 【選択年月関連】選択された年月の論理性チェック
    computedMonths() {
      if (!this.exportMonthFrom || !this.exportMonthTo) return []

      // 開始日を月の初日に設定
      let start = new Date(this.exportMonthFrom)
      start.setDate(1)

      // 終了日を月の最終日に設定。現在の月が選択されている場合は、当日のいずれか早い方に設定
      let end = new Date(this.exportMonthTo)
      const today = new Date()
      if (end.getMonth() === today.getMonth() && end.getFullYear() === today.getFullYear()) {
        end = Math.min(end, today)
      } else {
        // 選択月の最終日
        end = new Date(end.getFullYear(), end.getMonth() + 1, 0)
      }

      const months = []

      while (start <= end) {
        const year = start.getFullYear()
        const month = String(start.getMonth() + 1).padStart(2, '0')
        months.push(`${year}-${month}`)
        start.setMonth(start.getMonth() + 1)
      }

      return months
    },
    //【媒体】媒体名をとってきて表示・媒体名がない場合には媒体無しとする。
    mediaName() {
      const medium = new Set();
      this.aggregatedData.forEach(data => {
        const media = data.media_name || '媒体無し';
        medium.add(media);
      });
      return Array.from(medium);
    },
    //【媒体】媒体名をとってきて表示させ、応募者の件数が多い順番ソートする。
    sortedMediaName() {
      const mediaCountMap = new Map();
      this.aggregatedData.forEach(data => {
        const media = data.media_name || '媒体無し';
        const count = mediaCountMap.get(media) || 0;
        mediaCountMap.set(media, count + data.count);
      });
      return Array.from(mediaCountMap.entries())
        .sort((a, b) => b[1] - a[1])
        .map(entry => entry[0]);
    },
    //【媒体】選択された期間の応募者数総数が、一人以上いるのかどうか、判断
    totalMediaNameDataCount() {
      return this.aggregatedData.reduce((total, data) => total + data.count, 0)
    },
    //【媒体】年月毎の応募者数の総数
    totalByMonth() {
      const totalByMonth = {};
      this.computedMonths.forEach(month => {
        let total = 0;
        this.aggregatedData.forEach(data => {
          if (data.month && data.month.slice(0, 7) === month) {
            total += data.count;
          }
        });
        totalByMonth[month] = total;
      });
      return totalByMonth;
    },
    //【媒体】媒体毎の応募者数の総数
    totalByMediaName() {
      const totalByMediaName = {};
      this.sortedMediaName.forEach(media => {
        let total = 0;
        this.aggregatedData.forEach(data => {
          if ((data.media_name || '媒体無し') === media) {
            const dataMonth = data.month.slice(0, 7);
            if (this.computedMonths.includes(dataMonth)) {
              total += data.count;
            }
          }
        });
        totalByMediaName[media] = total;
      });
      return totalByMediaName;
    },
    //【媒体】表の総数
    grandTotal() {
      return Object.values(this.totalByMonth).reduce((a, b) => a + b, 0)
    },
    //【選考管理】応募者管理画面のステージ名データで、ステージが
    // 設定されてない場合には、設定なし、として、最右列に配置する。
    uniqueStages() {
      const stages = new Set(this.stageData.map(data => data.stage_name))
      const stagesArray = Array.from(stages)
      // 「設定なし」を最後にするためにソート
      stagesArray.sort((a, b) => {
        if (a === '設定なし') return 1
        if (b === '設定なし') return -1
        return 0
      })
      return stagesArray
    },
    //【選考管理】選択された期間の応募者数がゼロかどうか。
    totalStageDataCount() {
      return this.stageData.reduce((total, data) => total + data.count, 0)
    },
    //【時間帯別会話】選択された期間における、平均の会話数
    averageConversationsPerMonth() {
      const monthCount = this.computedMonths.length;
      return monthCount > 0 ? Math.floor(this.totalConversations / monthCount) : 0;
    },
    //【時間帯別会話】ロボ別データ用
      uniqueBots() {
      return [...new Set(this.messageData.map(data => data.bot_name_annotation))];
    },
    //【時間帯別会話】ロボのパーツ分類用
    uniqueStatuses() {
      return [...new Set(this.messageData.map(data => data.status))];
    },
    //【時間帯別会話】選択された期間の総会話数
    totalConversations() {
      return this.messageData.reduce((sum, data) => sum + data.count, 0);
    },
    // 変更: チェックボックスの選択状態を監視する計算プロパティを追加
    hasSelectedColumns() {
      return this.filteredReportColumns.some(column => column.is_report_flg);
    },
    allFieldsSelected() {
      return this.exportMonthFrom2 && this.exportMonthTo2 &&
             this.selectedFilterOption && this.selectedFilterValue.length > 0 &&
             this.selectedVerticalColumns1 && this.selectedVerticalColumns2 &&
             this.selectedHorizontalColumns1;
    },    
  },
  watch: {
    //【共通】集計したい期間の開始年月
    exportMonthFrom(newVal, oldVal) {
      if (this.exportMonthTo && this.exportMonthTo < newVal) {
        this.exportMonthTo = newVal
      }
      this.checkDateRange()
    },
    //【共通】集計したい期間の終了年月
    exportMonthTo(newVal, oldVal) {
      this.checkDateRange()
    }
  },
  methods: {
    ...mapActions('directtalk', ['aggregateSeekers']),
    ...mapActions('directtalk', ['aggregatedMessages']),
    ...mapActions('directtalk', ['companyReportColumns']),
    ...mapActions('directtalk', ['updateCompanyReportColumns']),
    ...mapActions('directtalk', ['updateSeekerSummaryTable2']),
    ...mapActions('directtalk', ['fetchFilterOptions']),
    ...mapActions('directtalk', ['fetchYearMonthRange']),
    ...mapActions('directtalk', ['fetchSeekerSummary']),

    // 求職者のサマリーデータを取得する非同期関数
    async fetchSeekerSummaryTabulation() {
      this.isLoading = true; // ローディング開始
      try {
        const user = this.user;
        if (!user) {
          alert("ユーザー情報が存在しません。");
          return;
        }
        if (!user.companyID) {
          alert("会社情報が存在しません。");
          return;
        }
        const companyId = user.companyPK
        const companyHash = user.companyID

        const filter = {
          option: this.selectedFilterOption,
          values: this.selectedFilterValue
        };

        const verticalColumn1 = this.selectedVerticalColumns1;
        const verticalColumn2 = this.selectedVerticalColumns2;
        const horizontalColumn1 = this.selectedHorizontalColumns1;

        // 選択された期間の開始日と終了日を取得
        const startDate = new Date(this.exportMonthFrom2);
        const endDate = new Date(this.exportMonthTo2);
        const today = new Date();

        if (endDate.getFullYear() === today.getFullYear() && endDate.getMonth() === today.getMonth()) {
          endDate.setDate(today.getDate()); // 現在の月の場合は、今日の日付を終了日に設定
        } else {
          endDate.setMonth(endDate.getMonth() + 1); // 次の月の初日に設定
          endDate.setDate(0); // 前の月の最終日に調整
        }

        const startDateStr = startDate.toISOString().split('T')[0];
        const endDateStr = endDate.toISOString().split('T')[0];

        // リクエストデータを作成
        const data = {
          company_id: companyId,
          company_hash: companyHash,
          filter: {
            option: this.selectedFilterOption,
            values: this.selectedFilterValue
          },
          vertical_column_1: verticalColumn1,
          vertical_column_2: verticalColumn2,
          horizontal_column: horizontalColumn1,
          start_date: startDateStr,
          end_date: endDateStr,
        };

        console.log('data:', data); //一連のレポート業務が完了したら削除すること

        const response = await this.fetchSeekerSummary(data)

        // 取得したデータを処理するロジックを追加
        if (response && response.data) {
          this.seekerSummaryData = response.data;
          this.verticalColumn1 = response.data.vertical_column_1;
          this.verticalColumn2 = response.data.vertical_column_2;
          this.horizontalColumn = response.data.horizontal_column;
          console.log('Seeker Summary Data:', this.seekerSummaryData);//一連のレポート業務が完了したら削除すること
        } else {
          alert('データの取得に失敗しました。');
        }
      } catch (error) {
          alert('データの取得中にエラーが発生しました。');
      } finally {
        this.isLoading = false; // ローディング終了
        this.showTable = true;
      }
    },

    // カラム名を取得する関数
    // column: カラムオブジェクトまたはカラム名の文字列
    // 返り値: カラム名の文字列
    getColumnName(column) {
      if (typeof column === 'string') {
        switch (column) {
          case 'media_name':
            return '媒体';
          case 'stage_name':
            return 'ステージ';
          case 'status_name':
            return 'ステータス';
          case 'action_name':
            return 'アクション';
          case 'yearmonth':
            return '年月';
          default:
            const columnData = this.seekerSummaryData.data.find(
              (row) => row[column] !== null && row[column] !== undefined
            );
            if (columnData) {
              return columnData[column];
            }
            const columnNameData = this.seekerSummaryData.data.find(
              (row) => row[`${column}_name`] !== null && row[`${column}_name`] !== undefined
            );
            if (columnNameData) {
              return columnNameData[`${column}_name`];
            }
            return column;
        }
      }
      return '';
    },

    // 指定したカラムのユニークな値を取得する関数
    // column: 対象のカラムオブジェクトまたはカラム名の文字列
    // verticalValue1: 縦軸1の値（オプション）
    // verticalValue2: 縦軸2の値（オプション）
    // 返り値: ユニークな値の配列
    getUniqueColumnValues(column, verticalValue1 = null, verticalValue2 = null) {
      if (!this.seekerSummaryData || !this.seekerSummaryData.data) {
        alert('getUniqueColumnValues: データがありません');
        return [];
      }

      let columnName = column;
      if (typeof column === 'object' && column !== null) {
        columnName = column.id;
      }

      let uniqueValues = [];

      if (verticalValue1 && verticalValue2) {
        uniqueValues = [
          ...new Set(
            this.seekerSummaryData.data
              .filter((row) =>
                (verticalValue1 === null || verticalValue1 === '-' || row[this.seekerSummaryData.vertical_column_1] === verticalValue1 || row[`${this.seekerSummaryData.vertical_column_1}_response`] === verticalValue1) &&
                (verticalValue2 === null || verticalValue2 === '-' || row[this.seekerSummaryData.vertical_column_2] === verticalValue2 || row[`${this.seekerSummaryData.vertical_column_2}_response`] === verticalValue2)
              )
              .map((row) => row[columnName] || row[`${columnName}_response`] || null)
              // .filter((value) => value !== null)空欄・ハイフンも絞られてしまうため、一旦非表示。今後もし絞った方がいいという話であれば、復活
          ),
        ];
      } else if (verticalValue1) {
        uniqueValues = [
          ...new Set(
            this.seekerSummaryData.data
              .filter((row) =>
                verticalValue1 === null || verticalValue1 === '-' || row[this.seekerSummaryData.vertical_column_1] === verticalValue1 || row[`${this.seekerSummaryData.vertical_column_1}_response`] === verticalValue1
              )
              .map((row) => row[columnName] || row[`${columnName}_response`] || null)
              // .filter((value) => value !== null) 空欄・ハイフンも絞られてしまうため、一旦非表示。今後もし絞った方がいいという話であれば、復活
          ),
        ];
      } else {
        uniqueValues = [
          ...new Set(
            this.seekerSummaryData.data
              .map((row) => row[columnName] || row[`${columnName}_response`] || null)
              // .filter((value) => value !== null)空欄・ハイフンも絞られてしまうため、一旦非表示。今後もし絞った方がいいという話であれば、復活
          ),
        ];
      }

      uniqueValues.sort((a, b) => {
        if (a === null || a === '-') return 1;
        if (b === null || b === '-') return -1;
        return a.localeCompare(b, 'ja', { sensitivity: 'base' });
      });

      return uniqueValues;
    },
    // 指定した縦軸と横軸の値に対応するカウント値を取得する関数
    // verticalValue1: 縦軸1の値
    // verticalValue2: 縦軸2の値
    // horizontalValue: 横軸の値
    // 返り値: カウント値
    getColumnValue(verticalValue1, verticalValue2, horizontalValue) {
      let horizontalColumnName = this.seekerSummaryData.horizontal_column;
      if (typeof this.seekerSummaryData.horizontal_column === 'string') {
        horizontalColumnName = this.seekerSummaryData.horizontal_column;
      }

      // フィルタリング条件を修正して、'-' と null を等価として扱う
      const filteredRows = this.seekerSummaryData.data.filter(row =>
        (verticalValue1 === '-' ? (row[this.seekerSummaryData.vertical_column_1] === null || row[`${this.seekerSummaryData.vertical_column_1}_response`] === null) : (row[this.seekerSummaryData.vertical_column_1] === verticalValue1 || row[`${this.seekerSummaryData.vertical_column_1}_response`] === verticalValue1)) &&
        (verticalValue2 === '-' ? (row[this.seekerSummaryData.vertical_column_2] === null || row[`${this.seekerSummaryData.vertical_column_2}_response`] === null) : (row[this.seekerSummaryData.vertical_column_2] === verticalValue2 || row[`${this.seekerSummaryData.vertical_column_2}_response`] === verticalValue2)) &&
        (horizontalValue === '-' ? (row[this.seekerSummaryData.horizontal_column] === null || row[`${this.seekerSummaryData.horizontal_column}_response`] === null) : (row[this.seekerSummaryData.horizontal_column] === horizontalValue || row[`${this.seekerSummaryData.horizontal_column}_response`] === horizontalValue))
      ).sort((a, b) => {
        if (a[this.seekerSummaryData.horizontal_column] === null || a[this.seekerSummaryData.horizontal_column] === '-') return 1;
        if (b[this.seekerSummaryData.horizontal_column] === null || b[this.seekerSummaryData.horizontal_column] === '-') return -1;
        return 0;
      });

      // 条件に一致するすべての行のカウントを合計する
      const total = filteredRows.reduce((acc, row) => acc + (row.count || 0), 0);

      return total || null; // カウントが0の場合は null を返す
    },

    // 指定した縦軸1と縦軸2の値に対応する行の合計を計算する関数
    // verticalValue1: 縦軸1の値
    // verticalValue2: 縦軸2の値
    // 返り値: 行の合計値
    calculateRowTotal(verticalValue1, verticalValue2) {
      return this.getUniqueColumnValues(this.horizontalColumn).reduce((sum, horizontalValue) => {
        const value = this.getColumnValue(verticalValue1, verticalValue2, horizontalValue);
        return sum + (value !== null ? value : 0);
      }, 0);
    },

    // verticalColumn2の中から、verticalValue1に対応するユニークな値を取得
    calculateVerticalSubtotal(verticalValue1, horizontalValue) {
      return this.getUniqueColumnValues(this.verticalColumn2, verticalValue1).reduce((sum, verticalValue2) => {
        const value = this.getColumnValue(verticalValue1, verticalValue2, horizontalValue);
        // valueがnullでない場合はsumに加算し、nullの場合は0を加算
        return sum + (value !== null ? value : 0);
      }, 0);
    },

    // 指定した縦軸1の値に対応する縦軸の合計を計算する関数
    // verticalValue1: 縦軸1の値
    // 返り値: 縦軸の合計値
    calculateVerticalTotal(verticalValue1) {
      return this.getUniqueColumnValues(this.horizontalColumn).reduce((sum, horizontalValue) => {
        return sum + this.calculateVerticalSubtotal(verticalValue1, horizontalValue);
      }, 0);
    },

    // 指定した横軸の値に対応する横軸の合計を計算する関数
    // horizontalValue: 横軸の値
    // 返り値: 横軸の合計値
    calculateHorizontalTotal(horizontalValue) {
      return this.getUniqueColumnValues(this.verticalColumn1).reduce((sum, verticalValue1) => {
        return sum + this.calculateVerticalSubtotal(verticalValue1, horizontalValue);
      }, 0);
    },

    // 総合計を計算する関数
    // 返り値: 総合計値
    calculateGrandTotal() {
      return this.getUniqueColumnValues(this.horizontalColumn).reduce((sum, horizontalValue) => {
        return sum + this.calculateHorizontalTotal(horizontalValue);
      }, 0);
    },

    // 指定した縦軸1の値に対応する行の縦軸2のユニークな値の数を取得する関数
    // verticalValue1: 縦軸1の値
    // 返り値: 縦軸2のユニークな値の数
    getRowSpan(verticalValue1) {
      return this.getUniqueColumnValues(this.verticalColumn2, verticalValue1).length;
    },
    
    // 選択したフィルターオプションに対応するフィルター値の選択肢を取得する関数
    // selectedFilterOption: 選択したフィルターオプション
    // 返り値: フィルター値の選択肢の配列
    getFilterOptions(selectedFilterOption) {
      if (selectedFilterOption === 'media_name') {
        return [...new Set(this.seekerSummaryData.data.map(row => row.media_name))].sort((a, b) => a.localeCompare(b, 'ja', { sensitivity: 'base' }));
      } else if (selectedFilterOption === 'stage_name') {
        return [...new Set(this.seekerSummaryData.data.map(row => row.stage_name))].sort((a, b) => a.localeCompare(b, 'ja', { sensitivity: 'base' }));
      } else if (selectedFilterOption === 'status_name') {
        return [...new Set(this.seekerSummaryData.data.map(row => row.status_name))].sort((a, b) => a.localeCompare(b, 'ja', { sensitivity: 'base' }));
      } else if (selectedFilterOption === 'action_name') {
        return [...new Set(this.seekerSummaryData.data.map(row => row.action_name))].sort((a, b) => a.localeCompare(b, 'ja', { sensitivity: 'base' }));
      } else if (selectedFilterOption.startsWith('column') && selectedFilterOption.endsWith('_response')) {
        return [...new Set(this.seekerSummaryData.data.map(row => row[selectedFilterOption]))].sort((a, b) => a.localeCompare(b, 'ja', { sensitivity: 'base' }));
      }
      return [];
    },

    // 年月の範囲データを取得する非同期関数
    async fetchYearMonthRangeColumn() {
      try {
        const user = this.user;
        if (!user) {
          alert("ユーザー情報が存在しません。");
          return;
        }
        if (!user.companyID) {
          alert("会社情報が存在しません。");
          return;
        }
        const companyId = user.companyPK;
        const response = await this.fetchYearMonthRange({ company_id: companyId });
        if (response && response.data) {
          // min_yearmonth2とmax_yearmonth2が存在する場合のみ設定する
          if (response.data.min_yearmonth2 && response.data.max_yearmonth2) {
            // min_yearmonth2が'1900-01-01'の場合は無視し、nullを設定する
            this.minYearMonth1 = response.data.min_yearmonth2 === '1900-01-01' ? null : new Date(response.data.min_yearmonth2);
            this.maxYearMonth1 = new Date(response.data.max_yearmonth2);
            // exportMonthTo2とexportMonthFrom2に日付の文字列表現を設定する
            this.exportMonthTo2 = this.formatDate(this.maxYearMonth1);
            // exportMonthFrom2はminYearMonth1がnullでない場合のみ設定する
            this.exportMonthFrom2 = this.minYearMonth1 ? this.formatDate(this.minYearMonth1) : null;
          } else {
            // データが存在しない場合は、現在の年月を設定する
            const currentDate = new Date();
            this.minYearMonth1 = null;
            this.maxYearMonth1 = currentDate;
            // exportMonthTo2とexportMonthFrom2に日付の文字列表現を設定する
            this.exportMonthTo2 = this.formatDate(currentDate);
            this.exportMonthFrom2 = null;
          }
        } else {
          alert('年月データの取得時にエラーが発生しました。');
        }
      } catch (error) {
        alert('年月データの取得時でエラーが発生しました。');
      }
    },

    // 日付オブジェクトを指定されたフォーマットの文字列に変換するメソッド
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      return `${year}-${month}`;
    },
    // 選択されたオプションに基づいてフィルターオプションを取得する
    getFilterOptions(selectedOption) {
      if (selectedOption === 'media_name') {
        return this.filterOptions.media_name;
      } else if (selectedOption === 'stage_name') {
        return this.filterOptions.stage_name;
      } else if (selectedOption === 'status_name') {
        return this.filterOptions.status_name;
      } else if (selectedOption === 'action_name') {
        return this.filterOptions.action_name;
      } else {
        return (this.filterOptions[selectedOption] && this.filterOptions[selectedOption].options) || [];
      }
    },

    // フィルターオプションを取得する非同期メソッド
    async fetchFilterOptions() {
      try {
        const response = await this.$store.dispatch('directtalk/fetchFilterOptions');

        if (response && response.data) {
          this.filterOptions = response.data;

          this.filterColumns = Object.entries(response.data)
            .filter(([key]) => key.startsWith('column'))
            .map(([key, value]) => ({ id: key, name: value.name }));

        } else {
          alert('集計項目が見つかりませんでした。（※未設定の場合には集計項目の設定をお願いします）');
        }
      } catch (error) {
        alert('フィルターオプションの取得時にエラーが発生しました。');
      }
    },
    // レポートカラムを取得する非同期メソッド
    async fetchReportColumns() {
      try {
        const user = this.user;

        if (!user) {
          alert("ユーザー情報が存在しません。");
          return;
        }

        if (!user.companyID) {
          alert("会社情報が存在しません。");
          return;
        }

        const companyId = user.companyPK
        const response = await this.companyReportColumns({ company_id: companyId });

        if (response && response.data) {
          this.reportColumns = response.data;
          // 初期選択状態を設定
          this.selectedReportColumnIds = this.reportColumns
            .filter(reportColumn => reportColumn.is_report_flg)
            .map(reportColumn => reportColumn.pk);
        } else {
          alert('カラムデータが取得できませんでした。');
        }
      } catch (error) {
        alert('カラムデータ取得でエラーが発生しました。');
      }
    },
    // レポートカラムが無効化されているかどうかを判定するメソッド
    isDisabled(reportColumn) {
      // チェック済みのカラムが最大数に達している場合、チェックされていないカラムはdisabledにする
      const selectedCount = this.reportColumns.filter(reportColumn => reportColumn.is_report_flg).length;
      return !reportColumn.is_report_flg && selectedCount >= this.maxReportColumns;
    },
    // レポートフラグを更新する非同期メソッド
    async updateReportFlgs() {
      // ローディング開始
      alert("集計のデータ量によっては、数分かかる場合がございます。しばらくしてからお立ち寄り下さい。（このままこちらのページにいらっしゃる場合、更新完了のタイミングでリロードされます）");
      this.isLoading = true;
      try {
        const user = this.user;

        if (!user) {
          alert("ユーザー情報が存在しません。");
          return;
        }

        if (!user.companyID) {
          alert("会社情報が存在しません。");
          return;
        }

        const companyId = user.companyPK
        const companyHash = user.companyID
        const selectedColumns = this.reportColumns.filter(reportColumn => reportColumn.is_report_flg);

        // 更新用のデータを作成
        const data = selectedColumns.map(reportColumn => ({
          company_id: companyId,
          id: reportColumn.pk,
          is_report_flg: true,
        }));

        const response = await this.updateCompanyReportColumns(data);

        if (response && response.data) {
          // 更新後の状態を再取得
          await this.fetchReportColumns();
          // サマリーテーブルの更新用データを作成
          const seekerSummaryTable2Data = selectedColumns.map(reportColumn => ({
            company_id: companyId,
            company_hash: companyHash,
            id: reportColumn.pk,
            is_report_flg: true,
          }));

          // Promiseを使ってサマリーテーブルの更新が完了するまで待機
          await new Promise(async (resolve) => {
            // Vuexのアクションを使ってサマリーテーブルを更新
            const seekerSummaryTable2Response = await this.updateSeekerSummaryTable2(seekerSummaryTable2Data);

            if (seekerSummaryTable2Response && seekerSummaryTable2Response.data) {
              alert('集計テーブルが更新されました。');
              resolve();
            } else {
              throw new Error('集計テーブルの更新に失敗しました。');
            }
          });
        } else {
          throw new Error('レポートカラムの更新に失敗しました。');
        }
        // ページ全体を更新
        location.reload();
      } catch (error) {
        alert('カラムデータ更新時にエラーが発生しました。');
      } finally {
        // ローディング終了
        this.isLoading = false;
      }
    },
    // エクセルのダウンロード
    downloadExcel() {
      const wb = XLSX.utils.table_to_book(document.querySelector('table'));
      XLSX.writeFile(wb, 'report.xlsx');
    },
    //【媒体】選択期間における、媒体別応募者データ取得（ボタン押下後の動き）
    async fetchAggregatedData() {
      // ローディング開始
      this.isLoading = true
      try {
        const user = this.user
        if (!user) {
          alert("ユーザー情報が存在しません。")
          return
        }
        if (!user.companyID) {
          alert("会社情報が存在しません。")
          return
        }
        if (!this.exportMonthFrom) {
          alert("集計開始月が選択されていません。")
          return
        }
        if (!this.exportMonthTo) {
          alert("集計終了月が選択されていません。")
          return
        }

        const companyId = user.companyID

        // 選択された期間の開始日と終了日を取得
        const startDate = new Date(this.exportMonthFrom)
        const endDate = new Date(this.exportMonthTo)
        const today = new Date()

        if (endDate.getFullYear() === today.getFullYear() && endDate.getMonth() === today.getMonth()) {
          // 現在の月の場合は、今日の日付を終了日に設定
          endDate.setDate(today.getDate())
        } else {
          // 次の月の初日に設定
          endDate.setMonth(endDate.getMonth() + 1)
          // 前の月の最終日に調整
          endDate.setDate(0)
        }

        const startDateStr = startDate.toISOString().split('T')[0]
        const endDateStr = endDate.toISOString().split('T')[0]

        const response = await this.aggregateSeekers({
          company_id: companyId,
          start_date: startDateStr,
          end_date: endDateStr,
        })

        if (response && response.data && response.data.length > 0) {
          this.aggregatedData = response.data
          // データ取得後、グラフ用のデータを準備する
          this.prepareChartData()
        } else {
          alert('媒体別応募集計データが取得できませんでした。')
        }
      } catch (error) {
        alert('媒体別応募集計データ取得でエラーが発生しました。')
      } finally {
        // ローディング終了
        this.isLoading = false
      }
    },
    //【媒体】媒体別応募者データのグラフ（ボタン押下後の動き）
    prepareChartData() {
      // 応募者数を基にグラフのデータを準備する
      const labels = this.sortedMediaName.map(media => media)
      const data = this.sortedMediaName.map(media => this.totalByMediaName[media])

      this.loadedChartData = {
        labels,
        datasets: [{
          label: '応募者数',
          backgroundColor: '#f87979',
          data
        }]
      }
    },
    //【媒体】媒体×年月別の応募者データ取得
    getDataByMediaNameAndMonth(media, month) {
      const matchingData = this.aggregatedData.find(data => {
        if (!data.month) {
          // monthデータが未定義の場合は無視
          return false
        }
        // "2023-03-01T00:00:00+09:00"の形式から"2023-03"の形式に変換
        const dataMonth = data.month.slice(0, 7)
        return (data.media_name || '媒体無し') === media && dataMonth === month
      })
      return matchingData ? matchingData.count : 0
    },
    //【時間帯別会話】選択期間における会話データの取得
    async fetchAggregatedMessages() {
      this.isLoading = true; // ローディング開始
      try {
        const user = this.user;
        if (!user) {
          alert("ユーザー情報が存在しません。");
          return;
        }
        if (!user.companyID) {
          alert("会社情報が存在しません。");
          return;
        }
        const companyId = user.companyID;

        // 選択された期間の開始日と終了日を取得
        const startDate = new Date(this.exportMonthFrom);
        const endDate = new Date(this.exportMonthTo);
        const today = new Date();

        if (endDate.getFullYear() === today.getFullYear() && endDate.getMonth() === today.getMonth()) {
          endDate.setDate(today.getDate()); // 現在の月の場合は、今日の日付を終了日に設定
        } else {
          endDate.setMonth(endDate.getMonth() + 1); // 次の月の初日に設定
          endDate.setDate(0); // 前の月の最終日に調整
        }

        const startDateStr = startDate.toISOString().split('T')[0];
        const endDateStr = endDate.toISOString().split('T')[0];

        const response = await this.aggregatedMessages({
          company_id: companyId,
          start_date: startDateStr,
          end_date: endDateStr,
        });
        if (response && response.data) {
          this.messageData = response.data;
          // データ取得後、グラフ用のデータを準備する
          this.prepareChartMessage(); // ここで prepareChartMessage を呼び出す
        } else {
          alert('データの取得に失敗しました。');
        }
      } catch (error) {
          alert('メッセージデータの取得中にエラーが発生しました。');
      } finally {
        this.isLoading = false; // ローディング終了
      }
    },
    //【時間帯別会話】選択期間における時間帯別データ取得
    prepareChartMessage() {
      const labels = ['09時', '10時', '11時', '12時', '13時', '14時', '15時', '16時', '17時', '18時', '19時', '20時', '21時', '22時', '23時', '00時', '01時', '02時', '03時', '04時', '05時', '06時', '07時', '08時'];

      const data = labels.map(hour => {
        const matchingData = this.messageData.filter(data => data.hour_label === hour);
        const totalCount = matchingData.reduce((sum, data) => sum + data.count, 0);
        return totalCount;
      });

      this.loadedChartData = {
        labels,
        datasets: [{
          label: 'ロボ会話数',
          backgroundColor: '#f87979',
          data
        }]
      };
    },
    //【選考状況別】選択期間における応募者の選考状況データの取得
    async fetchStageData() {
      // ローディング開始
      this.isLoading = true
      try {
        const user = this.user
        if (!user) {
          alert("ユーザー情報が存在しません。")
          return
        }
        if (!user.companyID) {
          alert("会社情報が存在しません。")
          return
        }
        if (!this.exportMonthFrom) {
          alert("集計開始月が選択されていません。")
          return
        }
        if (!this.exportMonthTo) {
          alert("集計終了月が選択されていません。")
          return
        }

        const companyId = user.companyID

        // 選択された期間の開始日と終了日を取得
        const startDate = new Date(this.exportMonthFrom)
        const endDate = new Date(this.exportMonthTo)
        const today = new Date()

        if (endDate.getFullYear() === today.getFullYear() && endDate.getMonth() === today.getMonth()) {
          // 現在の月の場合は、今日の日付を終了日に設定
          endDate.setDate(today.getDate())
        } else {
          // 次の月の初日に設定
          endDate.setMonth(endDate.getMonth() + 1)
          // 前の月の最終日に調整
          endDate.setDate(0)
        }
        const startDateStr = startDate.toISOString().split('T')[0]
        const endDateStr = endDate.toISOString().split('T')[0]

        const response = await this.aggregateSeekers({
          company_id: companyId,
          start_date: startDateStr,
          end_date: endDateStr,
        })

        if (response && response.data && response.data.length > 0) {
          // 受け取ったデータを加工
          const aggregatedData = response.data.map(item => ({
            ...item,
            // nullを「設定なし」に変換
            stage_name: item.stage_name || '設定なし',
          }))

          // 「設定なし」を最後にするためにソート
          aggregatedData.sort((a, b) => {
            if (a.stage_name === '設定なし') return 1
            if (b.stage_name === '設定なし') return -1
            // 件数が多い順
            return b.count - a.count
          })

          const stagesCount = {}

          // ステージ名ごとにカウントを集計
          aggregatedData.forEach(item => {
            const { stage_name, count } = item
            if (stagesCount[stage_name]) {
              stagesCount[stage_name] += count
            } else {
              stagesCount[stage_name] = count
            }
          })
          // 加工したデータをstageDataに格納
          this.stageData = Object.keys(stagesCount).map(stageName => ({
            stage_name: stageName,
            count: stagesCount[stageName],
          }))
        } else {
          alert('選考状況別集計データが取得できませんでした。')
        }
      } catch (error) {
        alert('選考状況別集計データ取得でエラーが発生しました。')
      } finally {
        this.isLoading = false
      }
    },
    //【選考状況別】選択期間における応募者のステージデータの取得
    getStageCount(stageName) {
      const stageData = this.stageData.find(data => data.stage_name === stageName)
      return stageData ? stageData.count : 0
    },
    //【媒体別】描画された媒体×年月別応募者集計表のエクエル貼付け用コピー（１）
    convertTableToTSV() {
      let tsv = ''
      const rows = document.querySelectorAll('table tr')
      for (const row of rows) {
        const cells = row.querySelectorAll('th, td')
        let rowData = []
        for (const cell of cells) {
          // テキストを取得し、必要に応じてダブルクォートで囲む
          // タブ区切り形式では、基本的にダブルクォートは不要ですが、
          // テキスト自体にカンマや改行が含まれている場合には適宜加工が必要です
          let text = cell.innerText
          // Excelに正しくインポートされるように、特定の文字をエスケープする
          // ダブルクォートをエスケープ
          text = text.replace(/"/g, '""')
          rowData.push(text)
        }
        // 行データをタブで結合し、改行を追加
        tsv += rowData.join('\t') + '\r\n'
      }
      return tsv
    },
    //【媒体別】描画された媒体×年月別応募者集計表のエクエル貼付け用コピー（２）
    async copyTableToClipboard() {
      const tsv = this.convertTableToTSV()
      try {
        await navigator.clipboard.writeText(tsv)
        alert('テーブルがクリップボードにコピーされました。Excelに貼り付け可能です。')
      } catch (err) {
        alert('クリップボードにコピーできませんでした。', err)
      }
    },
    //【期間選択】選択期間が２年越えかどうかのチェック
    checkDateRange() {
      if (this.exportMonthFrom && this.exportMonthTo) {
        const start = new Date(this.exportMonthFrom)
        const end = new Date(this.exportMonthTo)
        // 最大期間を24ヶ月（2年）とする
        const maxDuration = 24
        const duration = (end.getFullYear() - start.getFullYear()) * 12 + end.getMonth() - start.getMonth() + 1

        if (duration > maxDuration) {
          // 期間が2年を超える場合は、アラートを表示し、exportMonthToを調整
          if (this.alertShown === false) {
            alert('選択期間は最長2年間です。')
            this.alertShown = true
          } else {
            // すでにアラートが表示されている場合は処理をしない
            this.alertShown = false
          }
          this.exportMonthTo = this.adjustDateToMaxRange(this.exportMonthFrom)
        }
      }
    },
    //【期間選択】選択期間がの開始日（startDate）から2年後の年を計算し、
    // その結果の年月をISO 8601形式の文字列（YYYY-MM）で返しています。
    adjustDateToMaxRange(startDate) {
      const start = new Date(startDate)
      start.setFullYear(start.getFullYear() + 2)
      return start.toISOString().slice(0, 7)
    },
    // 【時間帯別会話】ロボ会話数の集計
    getConversationCount(bot, status) {
      return this.messageData.filter(data => data.bot_name === bot && data.status === status).reduce((sum, data) => sum + data.count, 0);
    },
    // 【時間帯別会話】ロボ毎の会話数の集計
    getTotalConversationsByBot(bot) {
      return this.messageData.filter(data => data.bot_name === bot).reduce((sum, data) => sum + data.count, 0);
    },
    // 【時間帯別会話】ロボのパーツ毎の会話数（使用数）の集計
    getTotalConversationsByStatus(status) {
      return this.messageData.filter(data => data.status === status).reduce((sum, data) => sum + data.count, 0);
    },
    // 【ロボパーツ別会話件数】status番号⇒パーツ名称に置換え。
    getStatusLabel(status) {
      const statusLabels = {
        0: '選択肢ありメッセージパーツ',
        1: '応募フォームパーツ',
        2: 'メッセージのみパーツ',
        3: 'ロボ切り替えパーツ',
        4: '日程自動調整パーツ',
        5: '画像パーツ',
        6: '自由入力パーツ',
        7: 'ファイルアップロードパーツ',
        8: '履歴書フォームパーツ',
        9: '最初から',
        10: 'メール送付パーツ',
        11: '- なし',
        12: '条件分岐パーツ',
        13: 'チェックボックスパーツ',
        14: '動画パーツ',
        15: 'プルダウンパーツ',
        16: 'SMS送付パーツ',
        17: 'カルーセルパーツ',
        18: 'ファイルダウンロードパーツ',
        20: '検索パーツ',
        21: '回答出力パーツ',
        22: '付箋パーツ',
        100: 'パーツセット'
      };
      return statusLabels[status] || 'Unknown';
    },
  },
  created() {
  this.fetchReportColumns();
  this.fetchYearMonthRangeColumn();
  },
}
</script>
<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  overflow: hidden;
}

/* 表頭のスタイル変更 */
body table thead th {
  background-color: #D50474;
  color: #ffffff;
  font-family: 'BIZ UDPGothic', sans-serif;
  font-size: 12px;
  padding: 12px 0;
  text-align: center;
  min-width: 70px;  
}
/* 表の行のスタイル変更 */
table tbody tr:nth-child(odd) {
  background-color: #f8f8f8;
}
table tbody tr:nth-child(even) {
  background-color: #ffffff;
}
table tbody td {
  font-family: 'BIZ UDPGothic', sans-serif;
  font-size: 14px;
  padding: 12px 0;
  text-align: center;
}

.table-container {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.5s ease-out forwards;
  max-width: 80vw;
  scrollbar-width: auto;
  margin: 10px 50px;  
}

.subtotal-row {
  background-color: #4ecdc4;
  color: #000000;
}

.total-row {
  background-color: #1a535c;
  color: #000000;
  font-weight: bold;
}

/* タイトル「＜媒体・年月別＞過去１２か月間応募者集計データ」のスタイル変更 */
.title-container {
  font-family: 'BIZ UDPGothic', sans-serif; /* BIZ UDPゴシックフォント */
  font-size: 15.0px; /* フォントサイズ12 */
  margin: 10px 40px;
  width: 800px;
}
.container-report {
  height: 100vh;
  width: 100%;
}
.container-list {
  height: 100vh;
  width: calc(100% - 205px);
  position: relative;
}
.container-list-thin-menu {
  height: 100vh;
  width: calc(100% - 55px);
  position: relative;
}
.header-box {
  width: calc(100% - 80px);
  margin: 10px 40px;
  margin-bottom: 25px;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: dotted 6px #323;
}
.header-menu {
  display: flex;
  justify-content: center;
  align-items: center;
}
.chat-container {
  width: 800px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 16px;
  height: 400px;
  overflow-y: scroll; /* スクロールバーを表示 */
  margin-bottom: 16px;
  margin: 10px 40px;
}
.chat-container::-webkit-scrollbar {
  width:  10px;
  height: 10px;
  visibility: visible !important;
}
.parent-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; /* 左揃えから中央揃えに変更 */
}
.title-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 10px 40px;
  width: 800px;
}
/* 期間選択と集計データ取得ボタンのコンテナのスタイルを追加 */
.title-container > div:last-child {
  display: flex;
  justify-content: center; /* 子要素を中央に寄せる */
  width: 100%; /* 必要に応じて調整 */
}

/* 期間選択のinput要素のスタイルを調整 */
.title-container input[type="month"] {
  width: 100%; /* inputの幅を親要素に合わせて調整 */
  /* カレンダーアイコンの右の余白を縮めるためのスタイル。実際のアイコンの実装によっては異なる場合がある */
}

/* 期間選択の欄の間隔を調整 */
.title-container > div:last-child > div {
  flex-grow: 1; /* 子要素の間の空白を均等に分配 */
}
.main-container {
  height: calc(100vh - 80px);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.input-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 40px;
  width: 800px;
}
input {
  flex-grow: 1;
  padding: 8px 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

button {
  margin-left: 8px;
  padding: 8px 16px;
  background-color: #AA0066;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #9D005E;
}

.copy-button {
  padding: 5px 10px;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  font-size: 12px;
  cursor: pointer;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease; /* スムーズな背景色の変化を追加 */
}

.copy-button:hover {
  background-color: #eee;
}

.copy-button:hover:not(.button-disabled) {
  background-color: #e2e2e2;
}

.button-disabled {
  color: #fff;
  background-color: #eee;
  cursor: not-allowed;
}

/* ボタンが有効化されたときのスタイル */
.copy-button:not(.button-disabled) {
  font-style: bold;
  color: #AA0066; /* 紫色 */
  background-color: #fff; /* 明るい青色、"集計データを取得"ボタンと同じ色に */
  border-color: #AA0066; /* 枠も同じ色に */
}

.copy-icon {
  margin-right: 5px;
}

.report-container {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  /* box-shadowを削除 */
}

.table-title {
  margin-bottom: 20px;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
}

.stage-table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  padding: 10px; /* テーブル自体にもパディングを適用して余白を作る */
  border-radius: 8px; /* テーブルの角を丸くする */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* テーブルに陰影を適用 */
  background-color: #fff; /* 背景色を白に指定 */
}

.stage-table th, .stage-table td {
  padding: 10px;
  border: 1px solid #ddd;
  font-size: 16px;
}

.stage-table .count {
  font-weight: bold;
  font-size: 20px;
}

.stage-table .unit {
  font-size: 12px;
  margin-left: 3px;
}

.custom-chart-width {
  width: 100%; /* 横幅を広げる */
  max-width: none; /* 最大幅の制限を解除する */
}
.aggregated-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.aggregated-table th,
.aggregated-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.aggregated-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.aggregated-text {
  font-size: 18px;
  margin-top: 10px;
  display: inline;
}

.aggregated-emtext {
  font-size: 36px;
  margin-top: 10px;
  color: #D50474;
  display: inline;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}


.loading-text {
  color: #fff;
  font-size: 18px;
  margin-top: 10px;
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.checkbox-container {
  max-height: 180px;
  overflow-y: auto;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}

.checkbox-container::-webkit-scrollbar {
  width: 8px;
}

.checkbox-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.checkbox-container::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px;
}

.checkbox-title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
}

.checkbox-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.checkbox-input {
  display: none;
}

.checkbox-checkmark {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 5px;
  border: 2px solid #ccc;
  border-radius: 4px;
  vertical-align: middle;
  transition: all 0.3s;
}

.checkbox-input:checked + .checkbox-checkmark {
  background-color: #2196F3;
  border-color: #2196F3;
  animation: checkmark-scale 0.3s ease;
}

.checkbox-input:checked + .checkbox-checkmark::after {
  content: "";
  display: block;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  margin: 2px 6px;
}

.checkbox-checkmark.disabled {
  background-color: #ddd;
  border-color: #aaa;
  cursor: not-allowed;
  opacity: 0.6;
}

.reflect-button {
  margin-top: 10px;
}

@keyframes checkmark-scale {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

.select-container {
  max-height: 200px;
  overflow-y: auto;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
  font-size: 14px;
  width: 50%;
  max-width: 300px;
  appearance: none;
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='%23888' d='M10 12.5a.5.5 0 01-.5-.5v-5a.5.5 0 011 0v5a.5.5 0 01-.5.5z'/%3E%3Cpath fill='%23888' d='M9.5 13a.5.5 0 01-.354-.146l-3-3a.5.5 0 01.708-.708L9.5 11.793l2.646-2.647a.5.5 0 01.708.708l-3 3A.5.5 0 019.5 13z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
}

.select-container::-webkit-scrollbar {
  width: 8px;
}

.select-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.select-container::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px;
}

.select-container option {
  padding: 8px;
}

.download-button {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #D50474;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.download-button:hover {
  background-color: #D50474;
}

.checkbox-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-bottom: 15px;
  width: 90%;
}
/* 変更: タイトルのスタイルを追加 */
.checkbox-section-title {
  font-family: 'BIZ UDPGothic', sans-serif; /* BIZ UDPゴシックフォント */
  font-size: 20px;
  margin-right: 20px; /* タイトルとボタンの間隔を調整 */
  margin-bottom: 15px;
  white-space: nowrap;
  text-align: center;
  margin: 0;
}
/* 変更: 薄いグレーの四角枠のスタイルを追加 */
.checkbox-outer-container {
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  width: 95%;
}
/* 変更: 4列グリッドのスタイルを追加 */
.checkbox-grid-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
}
.checkbox-item {
  display: flex;
  align-items: center;
}
/* 変更: ボタンのグレーアウトスタイルを追加 */
.reflect-button {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #D50474;
  color: #fff;
  border: none;
  border-radius: 4px;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.3s ease;
  &:hover:not(.disabled) {
    background-color: darken(#D50474, 10%);
  }
  &.disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
}
@media (max-width: 768px) {
  .checkbox-header {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  .reflect-button {
    width: 100%;
  }
  .checkbox-section {
    width: calc(100% - 80px);
    margin: 0 40px;
  }
}
.date-range {
  display: flex;
  align-items: center;
  gap: 20px;
}
.date-input-group {
  display: flex;
  align-items: center;
}
.date-input {
  width: 150px; /* カレンダーの幅を調整 */
  margin-left: 10px;
}

</style>


// WEBPACK FOOTER //
// src/views/DashBoard/Report/Report.vue